import { Layout, Modal } from "antd";
import { Content } from "antd/es/layout/layout";
import dayjs from "dayjs";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

import { ReactComponent as ICON_ARROW_BACK_MENU } from "@assets/svgs/ICON_ARROW_BACK_MENU.svg";
import { Button } from "@components/Button";
import Header from "@components/Header";
import { Icon } from "@components/Icon";
import { InnerContents } from "@components/InnerContents";
import { SideMenu } from "@components/SideMenu";
import { Text } from "@components/Text";
import {
  COLOR_BLACK,
  COLOR_GREEN,
  COLOR_GREY,
  COLOR_GREY_1,
  COLOR_WHITE,
} from "@static/COLORS";
import { CONTENT_STYLES } from "@static/CONTENT_STYLES";
import { MODAL_SIZE } from "@static/SIZE";
import { generateTimeSlots } from "@utils/generateTimeSlots";
import { fetchAPI } from "@utils/https/fetchAPI";

import { ViewPrediction } from "./ViewPrediction";

const ContainerTimeSlots = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${COLOR_WHITE};
  border-radius: 6px;
`;

const SectionTimeSlots = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

const SlotItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const SectionMainAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${COLOR_WHITE};
  padding: 8px;
  border-radius: 6px;
  height: 50px;
  box-sizing: border-box;
`;

const ContainerPrediction = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  overflow: scroll;
`;

export default () => {
  const navigate = useNavigate();
  const location = useLocation();
  const deviceId = _.get(location, ["state", "deviceId"]);

  const [campaigns, setCampaigns] = useState([]);
  const [expandedHours, setExpandedHours] = useState({});

  const [timeSlots, setTimeSlots] = useState([]);

  const [isModalVisible, setIsModalVisible] = useState({
    isOpen: false,
  });

  const initData = async () => {
    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/device-prediction",
      isAuth: true,
      data: { deviceId },
    });
    if (_.get(resp, ["status"])) {
      const campaignList = _.get(resp, ["result", "campaignList"]);
      setCampaigns(campaignList);
    }
  };

  useEffect(() => {
    const resultTimeSlots = generateTimeSlots();
    const timeSlots = _.groupBy(resultTimeSlots, (slot) => {
      return _.chain(slot).split(":").get([0]).value();
    });
    setTimeSlots(timeSlots);
    initData();
  }, []);

  const onHandleToggleHour = ({ hour }) => {
    setIsModalVisible({ isOpen: true });
    setExpandedHours(hour);
  };

  return (
    <Layout hasSider>
      <SideMenu />
      <Layout style={{ marginLeft: 240 }}>
        <Header />
        <Content style={CONTENT_STYLES}>
          <InnerContents>
            <SectionMainAction>
              <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
                <Button onClick={() => navigate(-1)} padding="0px">
                  <Icon
                    isCursor
                    width={14}
                    height={14}
                    style={{ marginRight: 8 }}
                  >
                    <ICON_ARROW_BACK_MENU />
                  </Icon>
                  <Text fontSize="18px" fontWeight="600">
                    Back
                  </Text>
                </Button>
              </div>
            </SectionMainAction>
            <ContainerTimeSlots>
              <div style={{ width: "70%", height: "70%" }}>
                <SectionTimeSlots>
                  {_.chain(timeSlots)
                    .keys()
                    .sortBy()
                    .map((item, index) => {
                      return (
                        <SlotItem key={index}>
                          <Button
                            onClick={() => onHandleToggleHour({ hour: item })}
                            width={"100px"}
                            color={COLOR_GREEN}
                            // disabled={index % 2 === 0}
                          >
                            <Text
                              fontWeight="600"
                              color={COLOR_WHITE}
                            >{`${item}:00`}</Text>
                          </Button>
                        </SlotItem>
                      );
                    })
                    .value()}
                </SectionTimeSlots>
              </div>
            </ContainerTimeSlots>
          </InnerContents>
        </Content>
      </Layout>
      <Modal
        width={MODAL_SIZE}
        destroyOnClose={true}
        title={`Prediction ( ${expandedHours}:00 )`}
        open={_.get(isModalVisible, ["isOpen"])}
        footer={null}
        onCancel={() => setIsModalVisible({ isOpen: false })}
      >
        <ViewPrediction
          timeSlots={timeSlots}
          expandedHours={expandedHours}
          campaigns={campaigns}
        />
      </Modal>
    </Layout>
  );
};
